import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PV, PVInfo } from './pv-info';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PVInfoService {

  BASE_URL = environment.urls.baseApiUrl; // Api URL
  Api = '/PVInfo';

  constructor(private http: HttpClient) { }

  getPVInfo(channel: any): Observable<PVInfo> {
    const pv = { pvName: channel } as PV;
    const httpresult = this.http.patch<PVInfo>(this.BASE_URL + this.Api + '/GetOne', pv);
    return httpresult;
  }

  getAll(): Observable<PV[]> {
    const httpresult = this.http.get<PV[]>(this.BASE_URL + this.Api);
    return httpresult;
  }

  subscribe(channel: string) {
    const pv = { pvName: channel } as PV;
    const httpresult = this.http.patch<PV>(this.BASE_URL + this.Api + '/SubscribePV', pv);
    return httpresult;
  }

  restartPVInfoService() {
    const httpresult = this.http.post(this.BASE_URL + '/BackgroundProcess/RestartPVS', null);
    return httpresult;
  }

  delete(id: number) {
    const httpresult = this.http.delete(this.BASE_URL + this.Api + '/' + id);
    return httpresult;
  }

}
